import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ADD_DELIVERY_TYPE, LANGUAGES_SEARCH } from "helpers/api_endpoints";


//meta title
document.title = "Add Delivery Type";

const AddDeliveryType = () => {

    const [name, setName] = useState('');
    const [code, setDeliveryTypeCode] = useState('');
    const [status, setStatus] = useState(0);
	const [valued, setValued] = useState({"title":[]});
	const [languages, setLanguages] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    const handleSubmit = () => {
        post(ADD_DELIVERY_TYPE, { name, status })
            .then(response => {
                if (response.code == 201) {
                    navigate('/delivery-types', { state: { successMsg: 'DeliveryType Added SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('DeliveryType Creation Failed');
            })
    }

	useEffect(() => {
		post(`${LANGUAGES_SEARCH}`,{status:1})
			.then(response => {
				setLanguages(response.data);
				// setLoading(false);
			})
			.catch(error => {
				console.log(error)
			})
	}, []);

	const handleName = (languageId,value) => {
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="DeliveryTypes" breadcrumbItem="Add DeliveryType" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
											{
												languages.map((language, index) => (
													<Row key={index}>
													<div className="form-group col-md-4 mt-2">
														<Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
														<Input
															name="name"
															// value={name}
															className="form-control"
															placeholder="Enter  Name"
															type="text"
															onChange={(e) => handleName(language.id,e.target.value)}
															required={language.id==1||language.id==2?true:false} ></Input>
													</div>
												</Row>
												))
											}

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                                                    <option value=''></option>
                                                    <option value={1} selected={status == 1}><Trans>Active</Trans></option>
                                                    <option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
                                                </select>
                                            </div>

                                        </Row>
                                        <div className="text-center  mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddDeliveryType
